<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'"
                                 type="select" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
					<c-form-item type="input" label="退货单号" name="return_number"></c-form-item>
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
					<c-form-item type="input" label="商户订单号" name="payment_number"></c-form-item>
					<c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
                    <c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="checkbox" label="退款单状态" name="return_state" :options="returnState" ></c-form-item>
					<c-form-item type="checkbox" label="售后类型" name="return_type" :options="returnType" ></c-form-item>
				</c-form>
			</m-search>
            <m-operate>
                <c-button color="m" hollow power="b_order_return_export"  @click="syncExport(1)">导出退货退款单</c-button>
                <c-button color="m" hollow power="b_order_return_export"  @click="syncExport(2)">导出退货退款单明细</c-button>

                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(detailWorkType)">编辑明细导出列</c-button>
                </template>
            </m-operate>
			<c-table ref="table" >
				<c-table-column
					type="selector"
				></c-table-column>

				<c-table-column
					label="售后类型"
					name="return_type"
					width="90"
				>
					<template v-slot="{data}">
						<span style="color:black" v-if="data.return_type==1">退货退款</span>
						<span style="color:red" v-if="data.return_type==2">仅退款</span>
					</template>
				</c-table-column>

				<c-table-column
					label="状态"
					name="return_state"
					width="90"
				>
					<template v-slot="{data}">
						<span style="color:#182eff" v-if="data.return_state==1">{{orderStateName[data.return_state]}}</span>
						<span style="color:dodgerblue" v-if="data.return_state==2">{{orderStateName[data.return_state]}}</span>
						<span style="color:dodgerblue" v-if="data.return_state==3">{{orderStateName[data.return_state]}}</span>
						<span style="color:darkgreen" v-if="data.return_state==5">{{orderStateName[data.return_state]}}</span>
						<span style="color:#999999" v-if="data.return_state==6">{{orderStateName[data.return_state]}}</span>
						<span style="color:#999999" v-if="data.return_state==8">{{orderStateName[data.return_state]}}</span>
					</template>
				</c-table-column>

				<c-table-column
					label="退货单号"
					name="return_number"
					width="130"
				></c-table-column>

				<c-table-column
					label="运营模式"
					name="operation_mode"
					width="80"
					v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'"
				>
					<template v-slot="{data}">
						{{operationModeName[data.operation_mode]}}
					</template>
				</c-table-column>

				<c-table-column
					label="商家角色"
					name="stationed_auth_name"
					width="120"
					v-if="systemConfig.pt_mode == 2 && systemConfig.stationed_authname_enabled == 'ON'"
				>
				</c-table-column>

				<c-table-column
					label="商家名称"
					name="stationed_name"
					width="150"
					v-if="systemConfig.pt_mode == 2"
				></c-table-column>

				<c-table-column
					label="订单号"
					width="120"
					name="order_number"
				></c-table-column>

				<c-table-column
					label="商户订单号"
					width="120"
					name="payment_number"
				></c-table-column>

				<c-table-column
					label="推送状态"
					name="push_state"
					width="80"
					v-if="systemConfig.order_push_enabled == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.return_state == 2 || data.return_state == 3 || data.return_state == 5">
							<span v-if="data.push_state==0"><span style="color:#bbbbbb">无需推送</span></span>
							<span v-if="data.push_state==1"><span style="color:#182eff">待推送</span></span>
							<span v-if="data.push_state==2"><span style="color:darkgreen">已推送</span></span>
						</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="售后三方单号"
					name="out_return_number"
					width="140"
					v-if="systemConfig.order_push_enabled == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.push_state==0">--</span>
						<span v-if="data.push_state==1">--</span>
						<span v-if="data.push_state==2">{{data.out_return_number}}</span>
					</template>
				</c-table-column>

				<c-table-column
					label="(寄回服务)收货状态"
					name="receiving_state"
					width="150"
				>
					<template v-slot="{data}">
						<span v-if="data.return_type == 1 && (data.return_state == 3 || data.return_state == 5)">
							<span v-if="data.receiving_state==0"><span style="color:#182eff">待收货</span></span>
							<span v-if="data.receiving_state==1"><span style="color:darkgreen">已收货</span></span>
						</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

                <c-table-column
                        label="会员手机号"
                        name="user_manage_mobilephone"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="会员头像/昵称"
                        name="head_photo"
                        width="120"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{data.nick_name||'--'}}</span>
                        </div>
                    </template>
                </c-table-column>

				<c-table-column
					label="退货服务数量"
					name="product_count"
                    width="120"
                ></c-table-column>

				<c-table-column
					label="退货服务金额"
					name="product_money"
                    width="120"
                >
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.product_money&&data.product_money>0">￥{{data.product_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>

				<c-table-column
					label="运费退款"
					name="logistics_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.logistics_money&&data.logistics_money>0">￥{{data.logistics_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>

				<c-table-column
					label="扣款金额"
					name="debit_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.debit_money&&data.debit_money>0">￥{{data.debit_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>

				<c-table-column
					label="实退金额"
					name="return_total_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.return_total_money&&data.return_total_money>0">￥{{data.return_total_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>

				<c-table-column
					label="申请时间"
					name="create_date"
					width="150"
				></c-table-column>

				<c-table-column
					label="审核时间"
					name="audit_date"
					width="150"
				>
				  <template v-slot="{data}">
					<span v-if="data.audit_date">{{data.audit_date}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>

				<c-table-column
					label="寄回物流公司"
					name="return_logistics_company"
					width="150"
				>
				</c-table-column>

				<c-table-column
					label="寄回物流单号"
					name="return_logistics_number"
					width="150"
				>
				</c-table-column>

				<c-table-column
                  label="打款到账时间"
                  name="remitter_date"
				  width="150"
				>
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
                    width="200"
                    label="操作"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/return_detail/${data.return_number}`)">查看</c-table-button>
						<c-table-button power="b_order_return_check" v-if="data.order_classify == 1 && data.operation_mode != 2 && data.return_state == 1 && data.return_type == 2" @click="checkReturnOrder(data.return_number)">同意申请</c-table-button>
						<c-table-button power="b_order_return_check" v-if="data.order_classify == 1 &&data.operation_mode != 2 && data.return_state == 1 && data.return_type == 1" @click="returnVerifyHandle(data.return_number,'resolve')">同意申请</c-table-button>
						<c-table-button power="b_order_return_finance_check" v-if="data.order_classify == 1 &&data.operation_mode != 2 && data.return_state == 3" @click="returnVerifyHandle(data.return_number,'return')">确认退款</c-table-button>
						<c-table-button power="b_order_return_finance_check" v-if="data.order_classify == 1 &&data.operation_mode != 2 && data.return_state == 1 || data.return_state == 3" @click="returnVerifyHandle(data.return_number,'reject')">驳回</c-table-button>
						<c-table-button power="b_order_return_finance_check" v-if="data.order_classify == 2 && data.operation_mode != 2 && data.return_state == 1 && data.return_type == 2" @click="returnVerifyHandle(data.return_number,'return')">同意申请并打款</c-table-button>
                    </template>
				</c-table-column>
			</c-table>
		</module>

		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>

        <c-dialog ref="rejectReason" :title="'驳回原因-'+afterSalesNumber" width="550" button-name="确认驳回" @resolve="rejectHandle">
            <div class="order-verify">
                <textarea v-model="rejectReason" placeholder="请输入驳回原因..."></textarea>
            </div>
        </c-dialog>

        <c-dialog ref="returnAddress" :title="'同意退货-'+afterSalesNumber" width="650" height="300" button-name="确认同意" @resolve="returnResolveHandle">
            <div class="order-verify">
                <div class="address flex-between-center">
                    <p><b>*</b>请选择退货地址：</p>
                    <div>
                        <a @click="navigateTo({name: 'm_after_sale_address'})">设置退货地址</a>
                        <a @click="getReturnAddress">刷新</a>
                    </div>
                </div>

                <c-radio-group v-model="returnAddress" column>
                    <c-radio v-for="(item, i) in returnAddressOptions" :key="i" :value="item.value">{{item.name}}</c-radio>
                </c-radio-group>
            </div>
        </c-dialog>

        <c-dialog ref="returnDebit" :title="'售后服务详情-'+afterSalesNumber" width="1000" button-name="确认并打款" @resolve="returnRemitHandle">
            <c-table ref="returnDebitList" v-model="debitList" height="400" :paging="false">
                <c-table-column
                    label="服务信息"
                    width="200"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                    </template>
                </c-table-column>

                <c-table-column
                    label="规格信息"
                    name="product_sku_spec"
                ></c-table-column>

                <c-table-column
                    label="单价"
                >
                    <template v-slot="{data}">
                        ￥{{data.product_order_unit_price}}
                    </template>
                </c-table-column>

                <c-table-column
                    label="退货数"
                >
                    <template v-slot="{data}">
                        ×{{data.product_count}}
                    </template>
                </c-table-column>

                <c-table-column
                    label="实付金额"
                >
                    <template v-slot="{data}">
                        ￥{{data.product_money}}
                    </template>
                </c-table-column>

                <c-table-column
                    label="凭证"
                >
                    <template v-slot="{data}">
                        <div  class="flex-center-cross" v-if="data.voucher_img_arr">
                            <c-image v-for="(medias, j) in data.voucher_img_arr" :key="j" class="img" :src="medias" size="80" preview></c-image>
                        </div>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                    label="扣款金额"
                >
                    <template v-slot="{data}">
                        <c-input v-model="data.debit_money" type="number" decimal="2" :limit="data.product_money"></c-input>
                    </template>
                </c-table-column>

                <c-table-column
                    label="实退金额"
                >
                    <template v-slot="{data}">
                        ￥{{parseFloat((data.product_money - (parseFloat(data.debit_money) || 0)).toFixed(2))}}
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>
	</page>
</template>

<script>
    import {mapState} from 'vuex'
    import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
    import productInfo from '@/components/public/product_info.vue'
    export default {
		name: 'm_order_return',

		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			stationedSelector,productInfo
		},

        props: {
            return_state: String
        },

		data() {
			return {
                workType:20,
                detailWorkType:21,
                searchParams:{},
                afterSalesNumber:'',
                orderStateName: {
					1: '待审核',
					2: '待用户退货',
					3: '待财务打款',
					5: '退款成功',
					6: '已驳回',
					8: '已撤销'
				},
                operationModeName: {
                    1: '平台自营',
                    2: '商家自营'
                },
                operationMode: [
                    {name: '平台自营',value: 1},
                    {name: '商家自营',value: 2}
                ],
				returnState: [{
						name: '待审核',
						value: 1
					},{
						name: '待用户退货',
						value: 2
					},{
						name: '待财务打款',
						value: 3
					},{
						name: '退款成功',
						value: 5
					},{
						name: '已驳回',
						value: 6
					},{
						name: '已撤销',
						value: 8
					}
				],
				returnType:[
					{name: '退货退款',value: 1},
					{name: '仅退款',value: 2}
				],
				returnAddressList: [],
				returnAddress: '',
				rejectReason: '',
				debitList: []
			}
		},

        computed: {
            ...mapState(['systemConfig', 'userInfo']),

            defaultSearch() {
                let param = {
                    return_state: this.return_state ? this.return_state.split(',') : [],
                }

                return param;
            },

            returnAddressOptions() {
                return Array.from(this.returnAddressList, item => {
                    return {
                        name: `${item.after_sale_name}，${item.after_sale_mobile}，${item.after_sale_address}`,
                        value: item.id
                    }
                });
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

		mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
			this.$bus.$on('return.update', data => {
				// 刷新列表
				this.$refs.table.update();
			});
		},

		methods: {
			searchHandle(data) {
				data.stationed_type = 1;
				this.$refs.table.load({
					url: '/returns/list',
					data
				});
                this.searchParams = data||{};
			},
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			},
			//仅退款的收货单
			checkReturnOrder(return_number){
				this.$confirm({
					text: '是否确认同意售后单【'+return_number+'】进行仅退款？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/returns/check',
							data:{
								return_number: return_number,
								return_state: 3 //待财务打款
							},
							loading: true,
							success: () => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			returnVerifyHandle(return_number, type, confirm) {
				this.afterSalesNumber = return_number;
				//同意申请
				if (type == 'resolve' && !confirm) {
					this.returnResolveHandle();
					return;
				//驳回申请
				} else if (type == 'reject' && !confirm) {
					this.rejectHandle();
					return;
				//确认退货退款
				} else if (type == 'return' && !confirm) {
					this.returnRemitHandle();
					return;
				}

				let returnAddress;
				if (type == 'resolve') {
					returnAddress = this.returnAddressList.find(item => item.id == this.returnAddress);
				}

				this.request({
					url: '/returns/check',
					data: Object.assign({
						return_number: this.afterSalesNumber,
						return_state: type == 'return' ? 5 : type == 'reject' ? 6 : 2,
						audit_reject_reason: this.rejectReason.trim(),
						return_skus: type == 'return' ? Array.from(this.debitList, item => {
							return {
								product_sku: item.product_sku,
								debit_money: parseFloat(item.debit_money) || 0
							}
						}) : ''
					}, type == 'resolve' ? {
						return_after_sale_name: returnAddress.after_sale_name,
						return_after_sale_mobile: returnAddress.after_sale_mobile,
						return_after_sale_address: returnAddress.after_sale_address
					} : {}),
					loading: true,
					success: () => {
						this.$message({
							text: '操作成功',
							icon: 'success'
						});
						this.$refs.table.update();
					}
				});
			},

			returnResolveHandle(stop) {
				if (!stop) {
					if (!this.returnAddressOptions.length) {
						this.getReturnAddress();
					}
					this.returnAddress = '';
					this.$refs.returnAddress.open();
				} else {
					stop();

					if (!this.returnAddress) {
						this.$message({
							text: '请选择退货地址'
						});
						return;
					}

					this.returnVerifyHandle(this.afterSalesNumber, 'resolve', true);
					this.$refs.returnAddress.close();
				}
			},

			getReturnAddress() {
				this.request({
					url: '/after_sale_address/list',
					data: {
						pageIndex: 1,
						pageSize: 20,
						state: [2]
					},
					loading: true,
					success: data => {
						this.returnAddressList = data;
					}
				});
			},

			returnRemitHandle(stop) {
				if (!stop) {
					this.request({
						url: '/returns/detail',
						data: {
							return_number: this.afterSalesNumber,
						},
						loading: true,
						success: data => {
							this.debitList = data.return_product_list;
							this.$refs.returnDebit.open();
						}
					});
				} else {
					stop();

					var total = 0;
					this.debitList.forEach(item => {
						total += parseFloat(item.debit_money) || 0;
					});

					this.$confirm({
						text: `确定要对该退货退款单立即执行打款操作吗？`,
						resolve: () => {
							this.returnVerifyHandle(this.afterSalesNumber, 'return', true);
							this.$refs.returnDebit.close();
						}
					});

				}
			},

			rejectHandle(stop) {
				if (!stop) {
					this.rejectReason = '';
					this.$refs.rejectReason.open();
				} else {
					stop();

					if (!this.rejectReason.trim()) {
						this.$message({
							text: '请填写驳回原因'
						});
						return;
					}

					this.returnVerifyHandle(this.afterSalesNumber, 'reject', true);
					this.$refs.rejectReason.close();
					this.$bus.$emit('return.update', {});
				}
			},
            /**
             * 同步导出数据
             * @param work_type
             */
            syncExport(type){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: type==1?this.workType:this.detailWorkType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>

<style lang="stylus" scoped>
	.order {
		&-verify {
			padding: 20px;
		
			.address {
				font-size: 13px;
		
				b {
					margin-right: 4px;
					color: #f00;
				}
		
				a {
					margin-left: 15px;
					color: #003DD9;
				}
			}
		
			.c-radio-group {
				margin: 20px 0;
			}
		
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 120px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}
</style>